import { sendPost } from 'helpers/axios';

export const apiSendMail = (params) => sendPost('/api/time-sheet/send-mail', params);
export const apiSendMailOT = (params) => sendPost('/api/time-sheet/send-mail-overtime', params);
